export class UIController {
    /**
     * ツイートボタンを読み込む。
     */
    setTweet() {
        /*jshint -W030 */
        (function f(d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (!d.getElementById(id)) {
                js = d.createElement(s);
                js.id = id;
                js.async = true;
                js.src = 'https://platform.twitter.com/widgets.js';
                fjs.parentNode.insertBefore(js, fjs);
            }
        })(document, 'script', 'twitter-wjs');
    }
    /**
     * ログをツイートする。
     */
    tweetlog(startMap, logArray2, level) {
        let url = document.location.href.split('?')[0];
        let init = '?init=' + startMap[55] + ',' +
            startMap[45] + ',' +
            startMap[35] + ',' +
            startMap[25] + ',' +
            startMap[15] + ',' +
            startMap[5] + ',' +
            startMap[44] + ',' +
            startMap[14];
        let log = '%26log=' + this.encodeLog(logArray2);
        log += '%26lv=' + level;
        window.open('https://twitter.com/intent/tweet?text=' + url + init + log + '%20%23colamone');
    }
    /**
 * 検討画面に飛ぶ
 */
    jumpkento(startMap, logArray2, level) {
        let url = document.location.href.split('?')[0];
        let init = '?init=' + startMap[55] + ',' +
            startMap[45] + ',' +
            startMap[35] + ',' +
            startMap[25] + ',' +
            startMap[15] + ',' +
            startMap[5] + ',' +
            startMap[44] + ',' +
            startMap[14];
        let log = '&log=' + this.encodeLog(logArray2);
        log += '&lv=' + level;
        location.href = url + init + log;
    }
    /**
     * ログをエンコード
     */
    encodeLog(wklogArray) {
        let logstr = '';
        let arrow = ['q', 'w', 'e',
            'a', 's', 'd',
            'z', 'x', 'c'];
        for (let i in wklogArray) {
            let from = wklogArray[i][0];
            let to = wklogArray[i][1];
            let x_vec = ((Math.floor(to / 10)) - Math.floor(from / 10));
            let y_vec = ((Math.floor(to % 10)) - Math.floor(from % 10));
            let arw = '';
            if (x_vec === -1 && y_vec === -1) {
                arw = 'q';
            }
            if (x_vec === 0 && y_vec === -1) {
                arw = 'w';
            }
            if (x_vec === 1 && y_vec === -1) {
                arw = 'e';
            }
            if (x_vec === -1 && y_vec === 0) {
                arw = 'a';
            }
            if (x_vec === 0 && y_vec === 0) {
                arw = 's';
            }
            if (x_vec === 1 && y_vec === 0) {
                arw = 'd';
            }
            if (x_vec === -1 && y_vec === 1) {
                arw = 'z';
            }
            if (x_vec === 0 && y_vec === 1) {
                arw = 'x';
            }
            if (x_vec === 1 && y_vec === 1) {
                arw = 'c';
            }
            logstr += from + arw;
        }
        return logstr;
    }
    updateScore(blue, red, time = null, wins = null) {
        document.querySelector('#blue').innerHTML = 'Blue: ' + blue + '/8';
        document.querySelector('#red').innerHTML = ' Red: ' + red + '/8';
        document.querySelector('#time').innerHTML = time === null ? '' : '(' + (time.toFixed(3)) + 'sec)';
        document.querySelector('#wins').innerHTML = wins === null ? '' : wins + ' win!';
    }
    setLevel(level) {
        document.querySelector('#level').value = level.toString();
    }
    getLevel() {
        return parseInt(document.querySelector('#level').value);
    }
    manual(show) {
        var _a, _b;
        if (show) {
            (_a = document.querySelector('.manual')) === null || _a === void 0 ? void 0 : _a.classList.remove("hide");
        }
        else {
            (_b = document.querySelector('.manual')) === null || _b === void 0 ? void 0 : _b.classList.add("hide");
        }
    }
    logMenu(show) {
        if (show) {
            document.querySelector('#log').classList.remove("hide");
            document.querySelector('#prevprev').classList.remove("hide");
            document.querySelector('#prev').classList.remove("hide");
            document.querySelector('#next').classList.remove("hide");
            document.querySelector('#nextnext').classList.remove("hide");
            document.querySelector('#span_replay').classList.add("hide");
            document.querySelector('#span_tweetlog').classList.add("hide");
            document.querySelector('#next').focus();
        }
        else {
            document.querySelector('#log').classList.add("hide");
            document.querySelector('#prevprev').classList.add("hide");
            document.querySelector('#prev').classList.add("hide");
            document.querySelector('#next').classList.add("hide");
            document.querySelector('#nextnext').classList.add("hide");
            document.querySelector('#span_replay').classList.add("hide");
            document.querySelector('#span_tweetlog').classList.add("hide");
        }
    }
    /**
     * ゲーム終了
     */
    endgame(logArray) {
        if (logArray.length === 0) {
            document.querySelector('#span_replay').classList.remove("hide");
            document.querySelector('#span_tweetlog').classList.remove("hide");
        }
    }
    /**
     * 小さい画面ではViewportを固定化
     */
    zoom() {
        let viewport = document.querySelector('meta[name=viewport]');
        if (screen.width < 500 && screen.height < 500) {
            if (screen.width < screen.height) {
                viewport.setAttribute('content', 'width=500,user-scalable=no');
            }
            else {
                viewport.setAttribute('content', 'height=500,user-scalable=no');
            }
        }
        else if (screen.width < 500) {
            viewport.setAttribute('content', 'width=500,user-scalable=no');
        }
        else if (screen.height < 500) {
            viewport.setAttribute('content', 'height=500,user-scalable=no');
        }
        // iOS9のViewportはなぜか機能してくれない。
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            let w = screen.width;
            let w2 = 520;
            if (Math.abs(window.orientation) !== 0) {
                w = screen.height;
                w2 = 900;
            }
            let rate = Math.round((w / w2) * 1000) / 1000.0;
            if (rate == Math.round(rate)) { // iOS 9のViewportは整数指定すると機能しない
                rate += 0.0001;
            }
            viewport.setAttribute('content', 'initial-scale=' + rate + ', minimum-scale=' + rate + ', maximum-scale=' + rate + ', user-scalable=no');
        }
    }
}
